import { AfterViewInit, Directive, EventEmitter, Injector, Input, OnDestroy, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgModel } from '@angular/forms';
import { RWidgetFormService } from '../form-render/r-widget-form/r-widget-form.service';
import { DynamicComponentBase } from './dynamic-component-base';
import { IDynamicComponent, IDynamicComponentConfig } from './interfaces';

@Directive()
export abstract class RenderComponentBase extends DynamicComponentBase implements AfterViewInit, OnDestroy {
  @ViewChild(NgModel) ngModel: any;

  _rWidgetFormService: RWidgetFormService;
  constructor(injector: Injector) {
    super();
    this._rWidgetFormService = injector.get(RWidgetFormService);
  }
  ngAfterViewInit() {
    // console.log(this, this.parent, 'RenderComponentBase ngAfterViewInit');
    this._rWidgetFormService.inputsChange(this);
  }

  ngOnDestroy(): void {
    // console.log(this, 'RenderComponentBase ngOnDestroy');
  }
}
